import React from "react";
import { useSelector } from "react-redux";
import { formatPhoneNumber } from "@qgiv/core-js";
import { PhonePreview } from "@qgiv/p2p-registration";
import { selectRegistrationsFromRegistration } from "../../../redux/slices/registrationSlice";
import { selectHasParentRegistration } from "../../../redux/slices/appSettingsSlice";
import { selectParentRegistration } from "../../../redux/slices/parentRegistrationSlice";

const ConnectedPhonePreview = () => {
    const registrations = useSelector(selectRegistrationsFromRegistration);
    const hasParentRegistration = useSelector(selectHasParentRegistration);
    const parentRegistration = useSelector(selectParentRegistration);
    const { Phone = "" } = hasParentRegistration
        ? parentRegistration
        : registrations[0];
    const phonePreviewProps = {
        Phone: formatPhoneNumber(Phone),
    };
    return <PhonePreview {...phonePreviewProps} />;
};

export default ConnectedPhonePreview;
